import {
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
  Button,
  Typography,
  Badge,
  Box,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import pic1 from "../../images/D2.png";
import pic2 from "../../images/D1.png";

export default function Spotlight() {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box sx={{ width: "100%", background: "#fff" }}>
      <section
        style={{
          width: "98%",
          margin: "auto",
          padding: "48px 16px",
          background: "#fff",
        }}
      >
        <Typography variant="h2" align="center" gutterBottom>
          Spotlight
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "32px",
            flexWrap: "wrap",
            // 1. Changed from "center" to "stretch" to force equal heights
            alignItems: "stretch", 
            justifyContent: "center",
          }}
        >
          {[
            {
              title: "The Future of GEN AI",
              badge: "AI & FUTURE",
              text: "The global GenAI market is projected to reach $100 billion by 2030, driven by its applications in healthcare, finance, and creative industries. However, challenges such as AI bias, ethical concerns, and regulatory issues remain critical. Future developments include multimodal AI, hyper-personalization, and AI-as-a-Service, shaping the next phase of digital transformation.",
              img: pic1,
              readMore: "/genai",
            },
            {
              title: "Trending Industry By 2030",
              badge: "INDUSTRY TRENDS",
              text: "India is on track to install over 500 GW of non-fossil electricity generation capacity by 2030. The e-commerce industry is projected to grow significantly, reaching $550 billion by 2035. The aerospace sector is evolving rapidly, with global giants like Airbus and Rolls-Royce sourcing components from India as the country moves towards advanced system integration",
              img: pic2,
              readMore: "/trending",
            },
          ].map((item, index) => (
            <Card
              key={index}
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                width: isMobile ? "100%" : "48%",
                // 2. Ensure the card itself takes up the full height of the flex container
                height: "auto", 
              }}
            >
              <div
                style={{
                  width: isMobile ? "100%" : "33%",
                  position: "relative",
                  minHeight: "300px", // Use minHeight instead of fixed height
                }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <Badge
                  sx={{
                    position: "absolute",
                    top: 16,
                    left: 16,
                    backgroundColor: "#10B981",
                    color: "white",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    "& .MuiBadge-badge": { display: "none" } // Hide default badge dot
                  }}
                >
                  {item.badge}
                </Badge>
              </div>
              <div
                style={{
                  width: isMobile ? "100%" : "67%",
                  padding: "24px",
                  // 3. Make this side a flex column so we can push the button to the bottom
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h4" // Adjusted from h3 for better hierarchy
                  sx={{ padding: 0, marginBottom: "16px" }}
                >
                  {item.title}
                </Typography>
                
                {/* 4. flexGrow: 1 ensures the text area takes up all available space */}
                <CardContent sx={{ flexGrow: 1, padding: 0 }}>
                  <Typography variant="body1" color="textSecondary">
                    {item.text}
                  </Typography>
                </CardContent>

                <CardActions sx={{ padding: "16px 0 0 0" }}>
                  <Button
                    href={item.readMore || "#"}
                    color="primary"
                    endIcon={<ArrowRightIcon />}
                  >
                    Read More
                  </Button>
                </CardActions>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </Box>
  );
}